export function SyncBadge({ lastSyncAt }: { lastSyncAt: string | null }) {
  let label = "Never synced";
  if (lastSyncAt) {
    const mins = Math.round((Date.now() - new Date(lastSyncAt).getTime()) / 60000);
    label = mins < 1 ? "Just now" : mins < 60 ? `${mins} min ago` : `${Math.round(mins / 60)}h ago`;
  }
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 999,
        background: "#FC4C02",
        color: "#fff",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.4,
        textTransform: "uppercase",
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 800 }}>S</span>
      {label}
    </span>
  );
}
